import * as THREE from "three";
import { FontLoader, type FontData } from "three/examples/jsm/loaders/FontLoader.js";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";
import { once } from "./kit";
import glyphs from "./glyphs.json";

/** 3D lettering from a 16 KB subset of three.js's helvetiker bold (A–Z 0–9 ? ! + -; MAGENTA licence inside the JSON). */
const font = () => once("font:helvetiker", () => new FontLoader().parse(glyphs as unknown as FontData));

/** Extruded, bevelled text centred on the origin, facing +z. */
export function text3D(text: string, size: number, depth: number, bevel: number, curveSegments = 5): THREE.BufferGeometry {
  return once(`g:text:${text}:${size}:${depth}:${bevel}:${curveSegments}`, () => {
    const g = new TextGeometry(text, {
      font: font(), size, depth, curveSegments,
      bevelEnabled: bevel > 0, bevelThickness: bevel, bevelSize: bevel * 0.8, bevelSegments: 2
    });
    g.computeBoundingBox();
    const b = g.boundingBox as THREE.Box3;
    g.translate(-(b.min.x + b.max.x) / 2, -(b.min.y + b.max.y) / 2, -(b.min.z + b.max.z) / 2);
    return g;
  });
}
